// auth
import type { RouteRecordRaw } from 'vue-router'

const authRoutes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/authentication/login.vue'),
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/authentication/logout.vue'),
  },
  {
    path: '/recoverpw',
    name: 'recoverpw',
    component: () => import('@/views/authentication/recoverpw.vue'),
  },
]

// error pages
const errorPageRoutes: Array<RouteRecordRaw> = [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/error-404.vue'),
  },
  {
    path: '/error-500',
    name: 'error-500',
    component: () => import('@/views/error/error-500.vue'),
  },
  {
    path: '/:catchAll(.*)',
    redirect: 'error-404',
  },
]

// dashboard
const dashboardRoutes: Array<any> = [
  {
    path: '',
    name: 'Dashboard',
    header: 'Navigation',
    icon: 'uil-home-alt',
    badge: {
      text: '5',
      variant: 'success',
    },
    meta: { authRequired: true },
    children: [
      {
        name: 'NEW',
        path: '',
        meta: { authRequired: true },
        component: () => import('@/views/dashboard/new.vue'),
      },
      {
        name: 'Shipments',
        path: 'shipments',
        meta: { authRequired: true },
        component: () => import('@/views/dashboard/shipments.vue'),
      },
      {
        name: 'Customers',
        path: 'customers',
        meta: { authRequired: true },
        component: () => import('@/views/dashboard/customers.vue'),
      },
      {
        name: 'Assignments',
        path: 'assignments',
        meta: { authRequired: true },
        component: () => import('@/views/dashboard/assignments.vue'),
      },
    ],
  },
]

// pages
const pagesRoutes: Array<any> = [
  {
    path: '/profile',
    name: 'Profile',
    header: 'Profile',
    icon: 'uil-copy-alt',
    badge: {
      text: '',
      variant: '',
    },
    meta: { authRequired: true },
    component: () => import('@/views/dashboard/profile.vue'),
  },
]

export const authProtectedRoutes = [...dashboardRoutes, ...pagesRoutes]

export const allRoutes = [...authRoutes, ...pagesRoutes, ...errorPageRoutes, ...authProtectedRoutes]
